const timezoneFormatReducer = (timezone = '0', action) => {
    switch (action.type) {
        case "ADD_TIMEZONE":
            return action.payload;
        default:
            return timezone;
    }
};

export default timezoneFormatReducer;